import ProductGridContainer from './ProductGridContainer';
export default ProductGridContainer;